var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonoBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "20 20 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#373B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#181A1D"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 144,
    height: 144,
    rx: 32
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "118.1%",
    height: "118.1%",
    x: "-9%",
    y: "-7.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.39 88V73.691c0-4.059-2.173-5.986-5.822-5.986-3.034 0-5.658 1.804-6.806 3.608-.738-2.255-2.583-3.608-5.494-3.608-3.034 0-5.658 1.886-6.478 3.075v-2.583h-5.207V88h5.207V74.675c.779-1.107 2.296-2.337 4.1-2.337 2.132 0 2.952 1.312 2.952 3.157V88h5.248V74.634c.738-1.066 2.255-2.296 4.1-2.296 2.132 0 2.952 1.312 2.952 3.157V88h5.248zm14.309.492c-6.519 0-10.455-4.756-10.455-10.414 0-5.617 3.936-10.373 10.455-10.373 6.56 0 10.496 4.756 10.496 10.373 0 5.658-3.936 10.414-10.496 10.414zm0-4.633c3.239 0 5.084-2.665 5.084-5.781 0-3.075-1.845-5.74-5.084-5.74s-5.043 2.665-5.043 5.74c0 3.116 1.804 5.781 5.043 5.781zM106.622 88V74.019c0-3.854-2.091-6.314-6.437-6.314-3.239 0-5.658 1.558-6.929 3.075v-2.583h-5.207V88h5.207V74.675c.861-1.189 2.46-2.337 4.51-2.337 2.214 0 3.649.943 3.649 3.69V88h5.207zm14.35.492c-6.519 0-10.455-4.756-10.455-10.414 0-5.617 3.936-10.373 10.455-10.373 6.56 0 10.496 4.756 10.496 10.373 0 5.658-3.936 10.414-10.496 10.414zm0-4.633c3.239 0 5.084-2.665 5.084-5.781 0-3.075-1.845-5.74-5.084-5.74s-5.043 2.665-5.043 5.74c0 3.116 1.804 5.781 5.043 5.781z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonoBank);
export default __webpack_public_path__ + "static/media/monoBank.bb1356be30f305eeb994b2dcce818f6a.svg";
export { ForwardRef as ReactComponent };